class HeroBanner{
    constructor(el) {
        this.scope = el;
        this.video = el.querySelector("video");
        this.toggle = el.querySelector("[data-play-pause]");
        this.bindEvents();
    }

    bindEvents(){
        this.toggle.addEventListener('click', () => {
            if (this.video.paused) {
                this.video.play();
            } else {
                this.video.pause();
            }
            this.toggle.querySelectorAll("span").forEach(span => span.classList.toggle("hidden"));
        });
    }
}
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-hero-banner] [data-play-pause]').forEach(el => new HeroBanner(el.closest("[data-hero-banner]")));
})

